import type { ReactNode } from "react";
import type { SchemeName, ThemeName } from "@web/theme/theme";
import { Text } from "./Text";

export type ThemeFrameProps = {
  theme: ThemeName;
  /** `system` follows the OS; `light`/`dark` force one side inside the frame. */
  scheme?: SchemeName;
  width: number;
  label?: string;
  children?: ReactNode;
  src?: string;
};

/**
 * Re-skins a subtree: sets `data-theme` / `data-scheme` on a fixed-width frame.
 * Used by the /dev/ui gallery; also proves the SPEC §6.2 mechanism.
 */
export function ThemeFrame({ theme, scheme = "system", width, label, children, src }: ThemeFrameProps) {
  return (
    <section className="flex flex-col gap-2 min-w-0">
      {label && (
        <Text variant="caption" tone="tertiary">
          {label}
        </Text>
      )}
      <div className="overflow-x-auto">
        {src ? <iframe title={label ?? `${theme} ${width}px preview`} src={src} style={{ width, minWidth: width }} className="v365-gallery-preview" /> : <div
          data-theme={theme}
          data-scheme={scheme === "system" ? undefined : scheme}
          style={{ width, minWidth: width }}
          className="bg-bg text-text hairline border-border rounded-card overflow-hidden"
        >
          {children}
        </div>}
      </div>
    </section>
  );
}
